import React from 'react';
import { shape, string, object } from 'prop-types';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { lazyLoadWithDimensions } from '../../util/uiHelpers';
import { FormattedMessage } from 'react-intl';

import css from './PlaceCard.module.css';

const PlaceImage = props => {
  const { alt, ...rest } = props;
  return <img alt={alt} {...rest} />;
};

const LazyImage = lazyLoadWithDimensions(PlaceImage);

const PlaceCard = props => {
  const {
    rootClassName,
    className,
    place: { key, srcImg, seoSlugs },
  } = props;

  const rootClass = rootClassName || css.root;
  const classes = classNames(rootClass, className);

  // ✅ SEO IMPROVEMENT: Get locale from Redux state (SSR-compatible)
  const { interfaceLang } = useSelector(state => state.ui);
  const locale = interfaceLang; // e.g., 'en-US'
  
  // Get the appropriate slug for current locale, fallback to English or lowercase key
  const slug = seoSlugs?.[locale] || seoSlugs?.['en-US'] || key.toLowerCase();
  
  // Map locale to SEO destination page base path
  const seoPageBasePaths = {
    'en-US': 'outdoor-destinations',
    'de-DE': 'outdoor-ziele',
    'fr-FR': 'destinations-outdoor',
    'it-IT': 'destinazioni-outdoor',
  };
  
  const basePath = seoPageBasePaths[locale] || 'outdoor-destinations';
  
  // Construct the full path: /{locale}/{basePath}/{slug}
  const destinationPath = `/${locale}/${basePath}/${slug}`;

  return (
    <Link
      to={destinationPath}
      className={classes}
    >
      <div className={css.imageWrapper}>
        <div className={css.aspectWrapper}>
          <LazyImage
            src={srcImg || '/static/imgs/laaxPlace.png'}
            alt={key}
            className={css.locationImage}
          />
        </div>
      </div>
      <div className={css.placeNameWrapper}>
        <span className={css.placeName}>
          <FormattedMessage id={`Place.${key}`} />
        </span>
      </div>
    </Link>
  );
};

PlaceCard.defaultProps = {
  rootClassName: null,
  className: null,
};

PlaceCard.propTypes = {
  rootClassName: string,
  className: string,

  place: shape({
    key: string.isRequired,
    srcImg: string,
    seoSlugs: object, // { 'en-US': 'switzerland', 'de-DE': 'schweiz', etc. }
  }),
};

export default PlaceCard;
